import { Component } from '@angular/core';

@Component({
  selector: 'mprd-default-loading-page',
  templateUrl: './default-loading-page.component.html',
})
export class DefaultLoadingPageComponent {
  constructor() {}
}
